import Image from '@atoms/Image/Image';
import { ILinkedImage } from '@models/ILinkedImage';
import PaginationCarousel from '@molecules/PaginationCarousel/PaginationCarousel';
import updateDataLayer from '@utils/helpers/gtm';
import slugify from '@utils/helpers/slugify';
import classNames from 'classnames';
import { useState } from 'react';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly linkedImages: ILinkedImage[];
}

const CompactAwardsCarousel = ({ linkedImages }: Props) => {
  const [hoverItemIndex, setHoverItemIndex] = useState<number | null>(null);

  return (
    <div className="overflow-swiper xl:col-span-10 xl:col-start-2">
      <PaginationCarousel
        id="Compact-Awards-Carousel"
        paginationClasses="mt-7.5 md:mt-10 md:hidden"
        swiperClasses="md:[&>.swiper-wrapper]:justify-center"
        spaceBetween={-20}
        slidesPerView={3.8}
        initialSlide={2}
        centeredSlides
        breakpoints={{
          768: {
            slidesPerView: 8,
            spaceBetween: -10,
            centeredSlides: false,
          },
          1024: {
            spaceBetween: -150,
            slidesPerView: 8,
            centeredSlides: false,
          },
          1440: {
            slidesPerView: 8,
            spaceBetween: -10,
            centeredSlides: false,
          },
          1920: {
            slidesPerView: 8,
            spaceBetween: -200,
            centeredSlides: false,
          },
        }}
      >
        {linkedImages
          .filter((linkedImage) => !!linkedImage)
          .map((linkedImage, index) => (
            <SwiperSlide
              key={slugify(
                linkedImage.image.desktop?.url
                  ? `${linkedImage.image.desktop.url}${index}`
                  : `${index}`
              )}
              className={classNames('inline-flex', {
                'z-20': hoverItemIndex === index,
                'z-10': hoverItemIndex !== index,
              })}
            >
              <a
                className="inline-flex"
                href={linkedImage.link.url}
                target={linkedImage.link.target}
                onClick={() =>
                  updateDataLayer({
                    event: 'awardsIcons',
                    link_url: linkedImage.link.url,
                  })
                }
              >
                <div
                  className={classNames(
                    'flex h-[93px] w-[93px] items-center overflow-hidden rounded-full border-2  p-2 align-middle xl:h-[160px] xl:w-[160px] xl:p-4',
                    {
                      'border-yellow bg-yellow': hoverItemIndex === index,
                      'border-white bg-black-100': hoverItemIndex !== index,
                    }
                  )}
                  onMouseOver={() => setHoverItemIndex(index)}
                  onMouseOut={() => setHoverItemIndex(null)}
                  onFocus={() => setHoverItemIndex(index)}
                  onBlur={() => setHoverItemIndex(null)}
                >
                  <div
                    className={classNames(
                      'small-text visible w-full bg-yellow text-center text-black-100',
                      {
                        hidden: hoverItemIndex !== index,
                      }
                    )}
                  >
                    {linkedImage.link.name}
                  </div>
                  <Image
                    key={linkedImage.image?.desktop?.url}
                    classes={classNames('visible', {
                      hidden: hoverItemIndex === index,
                    })}
                    image={linkedImage.image}
                    imageClasses="select-none w-full h-full object-contain min-h-[160px]"
                  />
                </div>
              </a>
            </SwiperSlide>
          ))}
      </PaginationCarousel>
    </div>
  );
};

export default CompactAwardsCarousel;
